import { Directive, ElementRef, HostListener } from '@angular/core';
import { ICatValues } from '../../models/CatalogosConfig';

@Directive({
  selector: '[numberPositiveOnlyMaxLength]'
})
export class numberPositiveOnlyMaxLengthDirective {
  // Only want positive integers
  private regex: RegExp = new RegExp(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/);
  // Allow key codes for special events Backspace, tab, end, home
  private specialKeys = ['Backspace', 'Tab', 'End', 'Home'];

  constructor(private el: ElementRef) { }
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) > -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }else{
      if(next.length > 3){
        event.preventDefault();     
      }
    }
  }
}